import React, { useEffect, useState } from "react";
import { usePermitted } from "../../common/components/permissions/permissions";
import TabbedContainer from "../../App/components/common/TabbedContainer";
import ProductAdmin from "./products/productAdmin";
import AliasAdmin from "./aliases/aliasAdmin";
import QualityAttributeAdmin from "./qualityAttributes/qualityAttributeAdmin";
import QualityAttributeValueAdmin from "./qualityAttributeValues/qualityAttributeValueAdmin";
import CommodityAdmin from "./commodities/commodityAdmin";
import CommodityClassAdmin from "./commodityClasses/commodityClassAdmin";
import { useTranslation } from "react-i18next";

const AuthAdmin = () => {
  const [activeTab, setActiveTab] = useState(null);
  const queryProducts = usePermitted(["api-query-products"]);
  const manageProducts = usePermitted(["api-manage-products"]);
  const queryCommodities = usePermitted(["api-query-commodities"]);
  const manageCommodities = usePermitted(["api-manage-commodities"]);
  const queryCommodityClasses = usePermitted(["api-query-commodity-classes"]);
  const manageCommodityClasses = usePermitted(["api-manage-commodity-classes"]);
  const queryAliases = usePermitted(["api-query-aliases"]);
  const manageAliases = usePermitted(["api-manage-aliases"]);
  const queryQualityAttributes = usePermitted(["api-query-quality-attributes"]);
  const manageQualityAttributes = usePermitted(["api-manage-quality-attributes"]);
  const queryQualityAttributeValues = usePermitted(["api-query-quality-attribute-values"]);
  const manageQualityAttributeValues = usePermitted(["api-manage-quality-attribute-values"]);
  // const queryQualityAttributeCommodities = usePermitted([
  //   "api-query-quality-attribute-commodities",
  // ]);
  // const manageQualityAttributeCommodities = usePermitted([
  //   "api-manage-quality-attribute-commodities",
  // ]);
  // const queryProductQualityAttributes = usePermitted(["api-query-product-quality-attributes"]);
  // const manageProductQualityAttributes = usePermitted([
  //   "api-manage-product-quality-attributes",
  // ]);
  const { t } = useTranslation(["products"]);
  const tabs = [
    queryProducts && {
      id: "1",
      label: t("Products"),
      content: <ProductAdmin allowEdit={manageProducts} />,
    },
    queryCommodities && {
      id: "2",
      label: t("Commodities"),
      content: <CommodityAdmin allowEdit={manageCommodities} />,
    },
    queryCommodityClasses && {
      id: "3",
      label: t("CommodityClasses"),
      content: <CommodityClassAdmin allowEdit={manageCommodityClasses} />,
    },
    queryAliases && {
      id: "4",
      label: t("Aliases"),
      content: <AliasAdmin allowEdit={manageAliases} />,
    },
    queryQualityAttributes && {
      id: "5",
      label: t("QualityAttributes"),
      content: <QualityAttributeAdmin allowEdit={manageQualityAttributes} />,
    },
    queryQualityAttributeValues && {
      id: "6",
      label: t("QualityAttributeValues"),
      content: (
        <QualityAttributeValueAdmin allowEdit={manageQualityAttributeValues} />
      ),
    },
  ].filter(Boolean);
  const firstTabId = tabs[0]?.id;
  const hasActiveTab = tabs.some((tab) => tab.id === activeTab);

  useEffect(() => {
    if (firstTabId && !hasActiveTab) {
      setActiveTab(firstTabId);
    }
  }, [firstTabId, hasActiveTab]);

  return (
    <TabbedContainer
      activeTab={activeTab ?? firstTabId ?? ""}
      onTabChange={setActiveTab}
      tabs={tabs}
    />
  );
};

export default AuthAdmin;

// class AuthAdmin extends Component {

//     render() {
//         return (

//         );
//     }
// }

// export default AuthAdmin;
